import Button from '../../../../components/Buttons/Button'
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import MultipleInputs from './MultipleInputs'
import { MdLoop } from "react-icons/md";
import { clearFilters, clearSelections, updateInitialFilters } from '../../../../redux/slices/openData/openDataFiltersSlice';
import { getIndicators } from '../../../../redux/slices/openData/openDataThunk';
import useUrlParams from '../../../../hooks/useUrlParams';
import { LIMIT_PAGINATION_OPEN_DATA } from '../../../../utils/const';
import { getIdsFromTitles } from '../../utils/getIdsFromTitles';
import { selectCanClearFilters, selectHasFilterChanges } from '../../../../redux/slices/openData/openDataFiltersSelectors';
import { FILTER_PARAMS_TO_REMOVE, SEARCH_PARAMS_TO_REMOVE } from '../../../../constants/params';
import { cleanSearch, setSearchValue } from '../../../../redux/slices/openData/openDataSlice';
import { scrollToElement } from '../../../../utils/utils';

interface ContainerFiltersProps {
    onApply?: () => void;
}

const ContainerFilters = ({ onApply }: ContainerFiltersProps) => {
    const dispatch = useAppDispatch();
    const { getParam, updateParams, removeParams } = useUrlParams();
    const filters = useAppSelector((state) => state.open_data_filters);
    const hasActiveFilters = useAppSelector(selectHasFilterChanges);
    const canClear = useAppSelector(selectCanClearFilters);

    //No limpia en variables
    const handleClear = () => {
        const allDerechosSelected = filters.filterOptions?.derechos
            ? filters.derechos.length === filters.filterOptions.derechos.length
            : false;

        const hasFilters = allDerechosSelected
            || filters.tiposIndicadores.length > 0
            || filters.dimensiones.length > 0
            || filters.ods.length > 0
            || filters.priorityGroups.length > 0
            || filters.variables.length > 0;

        const hasUrlParams = getParam('derechos')
            || getParam('type')
            || getParam('dimensiones')
            || getParam('ods')
            || getParam('priorityGroups')
            || getParam('variables');


        if (!hasFilters && !hasUrlParams) {
            return;
        }

        dispatch(clearFilters());
        removeParams(FILTER_PARAMS_TO_REMOVE);
        //limpia seleccionados p' descargar
        dispatch(clearSelections());

        if (hasUrlParams) {
            dispatch(getIndicators({
                page: 1,
                limit: LIMIT_PAGINATION_OPEN_DATA,
            }));
        }
        scrollToElement('open-data', -75, 500)
    };

    const handleApply = () => {
        const odsIds = getIdsFromTitles(filters, filters.ods, 'ods');
        const priorityGroupsIds = getIdsFromTitles(filters, filters.priorityGroups, 'gruposPrioritarios');

        //si existe un search, limpiar
        if (getParam('searchMode')) {
            dispatch(setSearchValue(""));
            removeParams(SEARCH_PARAMS_TO_REMOVE);
            dispatch(cleanSearch());
        }

        const allDerechosSelected = filters.filterOptions?.derechos
            ? filters.derechos.length === filters.filterOptions.derechos.length
            : false;

        const updates: Record<string, string | string[] | null> = {
            page: '1',
            derechos: !allDerechosSelected && filters.derechos.length > 0 ? filters.derechos : null,
            type: filters.tiposIndicadores.length > 0 ? filters.tiposIndicadores : null,
            dimensiones: filters.dimensiones.length > 0 ? filters.dimensiones : null,
            ods: filters.ods.length > 0 ? filters.ods : null,
            odsId: odsIds.length > 0 ? odsIds : null,
            priorityGroups: filters.priorityGroups.length > 0 ? filters.priorityGroups : null,
            priorityGroupsId: priorityGroupsIds.length > 0 ? priorityGroupsIds : null,
            variables: filters.variables.length > 0 ? filters.variables : null
        };

        updateParams(updates);
        //limpia seleccionados p' descargar
        dispatch(clearSelections());
        dispatch(getIndicators({
            page: 1,
            limit: LIMIT_PAGINATION_OPEN_DATA,
            derechos: !allDerechosSelected && filters.derechos.length > 0 ? filters.derechos : undefined,
            typeIndicator: filters.tiposIndicadores.length > 0 ? filters.tiposIndicadores : undefined,
            dimensiones: filters.dimensiones.length > 0 ? filters.dimensiones : undefined,
            ods: odsIds.length > 0 ? odsIds : undefined,
            gruposPrioritarios: priorityGroupsIds.length > 0 ? priorityGroupsIds : undefined,
            variables: filters.variables.length > 0 ? filters.variables : undefined
        }));
        dispatch(updateInitialFilters());

        onApply?.();
        scrollToElement('open-data', -75, 500)
    };

    return (
        <div className='bg-system-light-10 shadow-custom-dual md:rounded-md h-full'>
            <div className='bg-brand-green-15 border-b border-system-light-30 lg:rounded-t-md'>
                <h4 className='p-4 text-primary-100 text-tmedium'>FILTRO</h4>
            </div>
            <MultipleInputs />
            <div className='bg-brand-green-7 lg:rounded-b-md absolute bottom-0 lg:static w-full'>
                <div className='p-4 flex gap-4 w-full'>
                    <Button
                        label="Limpiar"
                        showIconLeft={false}
                        showIconRight={true}
                        icon={MdLoop}
                        className='bg-primary-100 !w-1/2 justify-center'
                        disabled={!canClear}
                        onClick={handleClear}
                        variant='outline-orange'
                    />
                    <Button
                        label='Aplicar'
                        showIconLeft={false}
                        showIconRight={false}
                        className='!w-1/2 justify-center'
                        disabled={!hasActiveFilters}
                        onClick={handleApply}
                        variant='primary'
                    /> 
                </div>
            </div>
        </div>
    )
}

export default ContainerFilters